import React, { useContext, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../../../components/Button'
import { GroupsDoVdContext } from '../../../../utils/context'
import Table from '../../../../components/Table'
import { Checkbox } from '../../../../components/ModalInputs'
import moment from 'moment'
import Empty from '../../../../components/Empty'
import EnrollModal from '../../EnrollModal'
import TransferModal from '../../TransferModal'

export default function Structure() {
    const { formik, id, type, params } = useContext(GroupsDoVdContext);
    const { values, setFieldValue } = formik;

    const [isShowModal, setIsShowModal] = useState(false);
    const [isShowTransferModal, setIsShowTransferModal] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);

    const handleSelect = (e, memberId) => {
        if (e.target.checked) {
            setSelectedIds(prev => [...prev, memberId]);
        } else {
            setSelectedIds(prev => prev.filter(id => id !== memberId));
        }
    };

    const handleOpenEnrollModal = () => {
        setIsShowModal(true);
    };

    const handleEnrollStudents = (mids, date, studentsData) => {
        if (mids.length === 0) {
            setIsShowModal(false);
            return;
        }

        // Добавляем локально - сохранение на сервер при нажатии "Сохранить"
        const newStudents = studentsData.map(s => ({
            mid: s.mid,
            fio: s.fio,
            school_class: s.school_class || '',
            enroll_date: date,
            isFromServer: false // локально добавленный
        }));
        const currentStructure = values.structure || [];
        setFieldValue('structure', [...currentStructure, ...newStudents]);
        setIsShowModal(false);
    };

    const handleOpenTransferModal = () => {
        if (selectedIds.length === 0) return;
        setIsShowTransferModal(true);
    };

    const handleTransferSuccess = () => {
        // Удаляем переведённых/отчисленных из локального списка
        const newStructure = values.structure?.filter(
            member => !selectedIds.includes(member.mid)
        );
        setFieldValue('structure', newStructure);
        setSelectedIds([]);
    };

    // Получаем данные выбранных студентов для передачи в модал
    const selectedStudents = values.structure?.filter(s => selectedIds.includes(s.mid)) || [];

    const renderRow = (data) => {
        const { mid, fio, school_class, enroll_date } = data;
        return (
            <tr key={mid}>
                <td>{fio}</td>
                <td>{school_class}</td>
                <td>{enroll_date ? moment(enroll_date).format('DD.MM.YYYY') : ''}</td>
                <td>
                    <Checkbox
                        checked={selectedIds.includes(mid)}
                        onChange={(e) => handleSelect(e, mid)}
                    />
                </td>
            </tr>
        );
    };

    return (
        <>
            <div className={styles.modalMain}>
                <div className={styles.tabWrapper}>
                    <div className={styles.buttons}>
                        {selectedIds.length > 0 && id !== 'add' && (
                            <Button
                                mode='white'
                                onClick={handleOpenTransferModal}
                            >
                                Перевод/Отчисление
                            </Button>
                        )}
                        <Button onClick={handleOpenEnrollModal}>
                            Зачисление
                        </Button>
                    </div>

                    {values?.structure?.length > 0 ? (
                        <div className={styles.tableWrapper}>
                            <Table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th>ФИО</th>
                                        <th>Класс</th>
                                        <th>Дата зачисления</th>
                                        <th>Выбрать</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {values.structure.map(renderRow)}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <Empty text='Список участников пуст' />
                    )}

                    <div className={styles.info}>
                        <span>Всего в группе: {values?.structure?.length || 0}</span>
                    </div>
                </div>
            </div>

            <EnrollModal
                isOpen={isShowModal}
                onClose={() => setIsShowModal(false)}
                onSave={handleEnrollStudents}
                existingMids={values?.structure?.map(s => s.mid) || []}
            />

            <TransferModal
                isOpen={isShowTransferModal}
                onClose={() => setIsShowTransferModal(false)}
                selectedStudents={selectedStudents}
                currentGroupId={Number(id)}
                currentGroupName={values.name}
                type={type}
                params={params}
                onSuccess={handleTransferSuccess}
            />
        </>
    );
}
